export function getMeasureUnit(measure) {
  const measureUnits = {
    mil: 'MIL',
    ctl: 'CTL',
    lt: 'LT',
    dz: 'DZ',
    bdj: 'BDJ',
    cx: 'CX',
    mm: 'MM',
    cm2: 'CM2',
    cm: 'CM',
    m3: 'M3',
    m2: 'M2',
    m: 'M',
    ml: 'ML',
    l: 'L',
    gr: 'GR',
    kg: 'KG',
    un: 'UN',
  }

  return measureUnits[measure]
}
